/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_PowerliftingInputs */

const en_us2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting`)
};

const pt_br2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting ou levantamento básico`)
};

const es_419_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting`)
};

const pt_pt2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting`)
};

const fr_fr2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting ou force athlétique`)
};

const de_de2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftdreikampf`)
};

const it_it2_modality_powerlifting = /** @type {(inputs: Modality_PowerliftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerlifting`)
};

/**
* | output |
* | --- |
* | "Powerlifting" |
*
* @param {Modality_PowerliftingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_powerlifting = /** @type {((inputs?: Modality_PowerliftingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_PowerliftingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_powerlifting(inputs)
	if (locale === "es-419") return es_419_modality_powerlifting(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_powerlifting(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_powerlifting(inputs)
	if (locale === "de-DE") return de_de2_modality_powerlifting(inputs)
	if (locale === "it-IT") return it_it2_modality_powerlifting(inputs)
	return en_us2_modality_powerlifting(inputs)
});
export { modality_powerlifting as "modality.powerlifting" }